import { useEffect, useState } from 'react';
import { API } from '../api';
import GaleriaCard from '../components/GaleriaCard';

import './Galeria.css';

function Galeria() {
  const [fotos, setFotos] = useState([]);

  useEffect(() => {
     window.scrollTo(0,0);
    API.get('galeria/')
      .then(res => setFotos(res.data))
      .catch(err => console.log(err));
  }, []);

  // Agrupar fotos por destino
  const fotosPorDestino = fotos.reduce((acc, foto) => {
    const destino = foto.destino_nombre || 'Otros';

    if (!acc[destino]) {
      acc[destino] = [];
    }

    acc[destino].push(foto);
    return acc;
  }, {});

  return (
    <div className="galeria-page">
      <h1 className="galeria-title">Galería</h1>

      <div className="galeria-secciones">
        {Object.keys(fotosPorDestino).map(destino => (
          <div key={destino} className="galeria-seccion">
            <h2 className="galeria-seccion-titulo">{destino}</h2>

           <div className="galeria-grid">
              {fotosPorDestino[destino].map(foto => (
                <GaleriaCard key={foto.id} foto={foto} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Galeria;
